export default __webpack_public_path__ + "static/media/dartboard4.33d4dc11.png";